import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { IconName } from '../../icons-container/icons.type';
import { ButtonComponent } from '../button/components/button/button.component';
import { IconButtonComponent } from '../button/components/icon-button/icon-button.component';
import { IconColorDirective } from '../icon/directives/icon-color.directive';
import { IconComponent } from '../icon/icon.component';
import { SubscriptionBannerTypeOptions } from './subscription-banner.types';

@Component({
  selector: 'rt-subscription-banner',
  templateUrl: './subscription-banner.component.html',
  styleUrls: ['./subscription-banner.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    IconColorDirective,
    IconComponent,
    RouterLink,
    IconButtonComponent,
    ButtonComponent,
  ],
})
export class SubscriptionBannerComponent {
  @Input() public type: SubscriptionBannerTypeOptions;
  @Input() public iconName: IconName;
  @Input() public message: string;
  @Input() public linkUrl: any[];
  @Input() public linkText: null | string;
  @Input() public linkBold: boolean;
  @Input() public contactText?: string;

  @Input() public isDismissible: boolean;

  @Output() public linkClick = new EventEmitter<void>();
  @Output() public closeBanner = new EventEmitter<MouseEvent>();

  public router = inject(Router);

  public onCloseClick(event: MouseEvent) {
    this.closeBanner.emit(event);
  }

  public get bannerMessage() {
    return this.message + (this.contactText ? ' ' + this.contactText : '');
  }
}
